import { defineQuery } from 'next-sanity'

export const careersTextAccordionBlockFields = `
  _id,
  _type,
  heading,
  mainText,
  accordionItems[]{
    heading,
    dropdownText
  },
  backgroundColor,
  variant
`

export const CAREERS_TEXT_ACCORDION_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-text-accordion-block"][0]{
    ${careersTextAccordionBlockFields}
  }
`)
